/* src/app/layout/vertical/layout-2/layout-2.component.scss */
vertical-layout-2 {
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
}
vertical-layout-2 #main {
  position: relative;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  width: 100%;
  height: 100%;
  z-index: 1;
  min-width: 0;
}
vertical-layout-2 #main > .container {
  position: relative;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
vertical-layout-2 #main > .container > .container {
  position: relative;
  display: flex;
  flex: 1 0 auto;
  width: 100%;
}
vertical-layout-2 #main > .container > .container > .container {
  position: relative;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
}
/*# sourceMappingURL=data:application/json;base64,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 */
